import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import uniqueId from 'lodash/uniqueId';

import tooltipImg from '../../assets/images/tooltip.svg';

import './index.css';


export const InlineTip = (props) => {
  const tipId = uniqueId();
  return (
    <span>
      <button
        type="button"
        styleName={!props.styleType ? 'tipBtn' : 'tipBtn2'}
        data-type="info"
        data-tip={props.text}
        data-for={tipId}
        data-event="click touchstart"
      >
        {props.children}
      </button>
      <ReactTooltip
        styleName={props.tooltipTheme ? props.tooltipTheme : 'tooltipTheme'}
        id={tipId}
        effect="solid"
        globalEventOff="click"
        data-html={!!props.dataHtml}
      >
        <span styleName="tooltip">{props.text}</span>
      </ReactTooltip>
    </span>
  );
};

const Tooltip = (props) => {
  const tipId = uniqueId();
  return (
    <div style={props.styles}>
      <img
        data-type="info"
        styleName="tooltipImg"
        type="image"
        src={tooltipImg}
        alt={props.text}
        data-tip={props.text}
        data-for={tipId}
        data-event="click"
      />
      {props.children ?
        <ReactTooltip
          styleName="tooltipThemeBigText"
          id={tipId}
          effect="solid"
          globalEventOff="click"
        >
          {props.children}
        </ReactTooltip>
        :
        <ReactTooltip
          styleName="tooltipTheme"
          id={tipId}
          effect="solid"
          globalEventOff="click"
        >
          <div styleName="tooltip">{props.text}</div>
        </ReactTooltip>
      }
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js